import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Location {
  id: string
  name: string
}

export interface UseLocationsResult {
  locations: Location[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useLocations(): UseLocationsResult {
  const [locations, setLocations] = useState<Location[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ locations: Location[] }>('/locations/dropdown')
      setLocations(res.locations || [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch locations')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { locations, loading, error, refetch }
}
